import InfoIcon from 'Components/Icons/InfoIcon'
import FormErrorBanner from 'Components/Element/FormErrorBanner'
import NewOrgProfile from './NewOrgProfile'
import React, { useContext, useEffect, useState } from 'react'
import AreYouSureModal from 'Modals/AreYouSureModal';
import { getUserApprovalListApi } from 'Constants';
import { Context } from 'Context/Context';
import ProfessionalAccountUpdates from './ProfessionalAccountUpdates';

function ChangeOrg({setActivePanel}) 
{
    const {makeApiCallFunc, userDetails} = useContext(Context);
    const [showModal, setShowModal] = useState(false);
    const [showUpdatesSent, setShowUpdatesSent] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [updatesSent, setUpdatesSent] = useState(null);
    const [reRenderData, setReRenderData] = useState(false);

    useEffect(() => {
        makeApiCallFunc(getUserApprovalListApi+'/'+userDetails?._id, null,
        successCallback,
        (data) => console.log(data)
        )
    },[reRenderData])
    const successCallback = (data) => {
        if(data?.data?.changeOrg)
        {
            console.log("changeOrg data", data);
            setShowUpdatesSent(true);
            setUpdatesSent(data?.data);
        }
        else
        {
            setShowModal(true);
            setShowUpdatesSent(false);
        }
    }

  return (
    <div>
        
        {
            showModal &&
            <AreYouSureModal
            uploadNew= {showModal}
            doNotClose = {false}
            onClose={()=> setShowModal(false)}
            onBack = {() => setActivePanel(0)}
            onSubmit = {()=> {setShowEdit(true); setShowModal(false)}} 
            buttonName="Proceed"
            text= "You can edit your firm details including your work email. Please be aware that your statistics will remain but any case data that is in progress will be lost. This action is irreversible and a new login will be created using the new work email that you will enter here."
            />
        }
        {
            showUpdatesSent &&
            <>
            {
                updatesSent.deniedMessage ?
                <>
                <FormErrorBanner>
                  <b>Status message:</b> Details you submitted were denied by the admin so law firm details has not been switched. Please refer and make a new request
                  <br/>
                  <b>Admin's message:</b> {updatesSent.deniedMessage}
                </FormErrorBanner>
                </>
                :
                <div className='flex justify-center items-start lg:mx-20 px-2 py-2 border-yellow-200 border-2 lg:mb-10 lg:mt-10 text-sm font-bold bg-yellow-50'><InfoIcon/> &nbsp; The law firm details submitted by you for approval. Once this gets approved a temporary credentials will be sent to your new email and you can login using the same.</div>

            }
            <ProfessionalAccountUpdates
            labels = {{
                  "Profile picture" : "profilePic",   
                  "First name" : "firstName",
                  "Last name" : "lastName",
                  "Email" : "email",
                  "Company" : "company",
                  "Designation" : "legalType",
                  "Law Firm Link" : "lawFirmLink",
                  "LinkedIn URL" : "linkedin",
                  "Phone number" : "phoneNumber",
                  "Experience" : "experience",
                  "Case Preference" : "casePref",
                  "State Preference" : "statePref"
                 }}
            updatesSent={updatesSent}
            buttonName = "Resubmit Firm Details"
            setReRenderData={setReRenderData}
            isDenied={false}
            showEditOrPopup={()=>{setShowEdit(true)}}
            />
            </>
        }
        {showEdit &&
        <>
        <div className='flex justify-center items-start mx-20 px-2 py-2 border-yellow-200 border-2 mb-10 mt-10 text-sm font-bold bg-yellow-50'><InfoIcon/> &nbsp; If you are changing your organisation, you shall change your firm related information and email here. Please note that this action is irreversible and all informations related to your cases will be removed</div>
        <NewOrgProfile setActivePanel={setActivePanel}/>
        
        </>
        }
    </div>
  )
}

export default ChangeOrg